import { useCallback } from 'react';
import { StepStatus } from '~/enums';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import { goToNextStep } from '~/store/slices/loanApplication.slice';

const useSkip = () => {
  const dispatch = useAppDispatch();

  const onSkip = useCallback(() => {
    dispatch(pushToGtmLoanAction({ actionName: 'skip_button_pressed' }));
    dispatch(pushToGtmLoanAction({ stepStatus: StepStatus.Finished }));
    dispatch(goToNextStep());
  }, [dispatch]);

  return onSkip;
};

export default useSkip;
